import { DateConverter } from 'src/app/core/services/mapper/converters';
import { EntrepriseBase } from './entreprise-base.model';
import { Fonction } from './fonction.model';
import { Groupe } from './groupe.models';
import { Referent } from './referent.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';
import * as moment from 'moment';

export class Contact {
    static jsonMap = {
        id: { key: 'id', optional: true },
        mail: { key: 'mail', optional: true, default: '' },
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' },
        civilite: { key: 'civilite', optional: true, default: '' },
        entreprise: { key: 'entreprise', converter: new (ClassConverterFactory.build(EntrepriseBase))(), optional: true },
        fonction: { key: 'fonction', converter: new (ClassConverterFactory.build(Fonction))(), optional: true },
        telephonefixe: { key: 'telephonefixe', optional: true, default: '' },
        telephoneportable: { key: 'telephoneportable', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codepostal: { key: 'codepostal', optional: true, default: '' },
        commune: { key: 'commune', optional: true, default: '' },
        estintervenant: { key: 'estintervenant', optional: true },
        referents: { key: 'referents', converter: new (ArrayClassConverterFactory.build(Referent))(), default: () => [] },
        groupes: { key: 'groupes', converter: new (ArrayClassConverterFactory.build(Groupe))(), default: () => [] },
        dateDerniereConnexion: { key: 'dateDerniereConnexion', converter: new DateConverter(), optional: true }
    };

    public id: number;
    public mail: string;
    public nom: string;
    public prenom: string;
    public civilite: string;
    public entreprise: EntrepriseBase;
    public fonction: Fonction;
    public telephonefixe: string;
    public telephoneportable: string;
    public adresse: string;
    public codepostal: string;
    public commune: string;
    public estintervenant: boolean;
    public referents: Referent[];
    public groupes: Groupe[];
    public dateDerniereConnexion: moment.Moment;
}
